import { DialogTitle, Paper } from "@material-ui/core";
import { LoadingButton } from "@mui/lab";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Grid,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import useToast from "../../../hooks/useToast";
import { TYPE_NOTIFICATION } from "../../../components/reusable/NotificationBull";
import { evaluation_refonte_category_service } from "../../../services/PersonalEvaluationRefonteService";

const CategoryCritereForm = ({
  isOpen,
  current_category_critere,
  handleClose,
}) => {
  const { showToast, Toast } = useToast();
  const [submitLoad, setLoadSUbmit] = useState(false);
  const [category_critere, setCategoryCritere] = useState({
    ID_CATEGORY: 0,
    CATEGORY_NAME: "",
  });

  const handleInitForm = () => {
    setCategoryCritere({ CATEGORY_NAME: "", ID_CATEGORY: 0 });
  };

  const handleSubmit = () => {
    if (isAllFieldOk()) {
      if (category_critere.ID_CATEGORY > 0) {
        handleUpdateCategory();
      } else {
        handleInsertCategory();
      }
    }
  };
  const isAllFieldOk = () => {
    let ok = false;
    if (!category_critere.CATEGORY_NAME) {
      ok = false;
      showToast(
        TYPE_NOTIFICATION.ERROR,
        "Le nom de la catégorie est obligatoire"
      );
    } else {
      if (category_critere.CATEGORY_NAME.trim() === "") {
        showToast(
          TYPE_NOTIFICATION.ERROR,
          "Le nom de la catégori est obligatoire"
        );
        ok = false;
      }
      ok = true;
    }
    return ok;
  };

  const handleInsertCategory = () => {
    evaluation_refonte_category_service
      .insert(category_critere)
      .then((res) => {
        if (res && res.success) {
          handleClose();
          clearAllFields();
          showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
        } else {
          showToast(TYPE_NOTIFICATION.ERROR, res.message);
        }
      })
      .finally(() => {
        handleInitForm();
      });
  };

  const handleUpdateCategory = () => {
    evaluation_refonte_category_service
      .update(category_critere)
      .then((res) => {
        if (res && res.success) {
          handleClose();
          clearAllFields();
          showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
        } else {
          showToast(TYPE_NOTIFICATION.ERROR, res.message);
        }
      })
      .finally(() => {
        handleInitForm();
      });
  };

  useEffect(() => {
    evaluation_refonte_category_service
      .getOne(current_category_critere.ID_CATEGORY)
      .then((res) => {
        if (res && res.success) {
          setCategoryCritere(res.data);
        }
      });
  }, [current_category_critere, isOpen]);

  const clearAllFields = () => {
    setCategoryCritere({ ID_CATEGORY: 0, CATEGORY_NAME: "" });
  };

  const handleChangeCategoryCritere = (evt) => {
    const { name, value } = evt.target;
    setCategoryCritere({ ...category_critere, [name]: value });
  };

  const handleDialogClose = () => {
    handleClose();
    clearAllFields();
  };
  return (
    <>
      <Toast />
      <Dialog
        open={isOpen}
        /* onClose={ handleDialogClose} */
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
        fullWidth
        maxWidth="sm"
      >
        <Paper>
          <Grid
            container
            height={"100%"}
            display={"flex"}
            flexDirection={"column"}
            overflow={"auto"}
          >
            <DialogTitle id="dialog-title" className="entete-dialog">
              {category_critere.ID_CATEGORY > 0
                ? "Modifier Categorie critère"
                : "Nouvelle Categorie critère"}
            </DialogTitle>
            <DialogContent
              id="dialog-description"
              className="app-scroll-bar-view"
              sx={{ maxHeight: "73vh", overflow: "auto" }}
            >
              <Grid flexDirection={"row"} mt={0.5}>
                <TextField
                  size="small"
                  fullWidth
                  label="Nom de la catégorie"
                  name="CATEGORY_NAME"
                  value={category_critere.CATEGORY_NAME}
                  onChange={(e) => handleChangeCategoryCritere(e)}
                />
              </Grid>
            </DialogContent>
            <Divider variant="middle" />
            <DialogActions>
              <LoadingButton
                loading={submitLoad}
                size="small"
                className="form_control"
                type="submit"
                onClick={handleSubmit}
                variant="contained"
              >
                Valider
              </LoadingButton>
              <Button
                className="form_control"
                size="small"
                onClick={handleDialogClose}
                variant="outlined"
              >
                Fermer
              </Button>
            </DialogActions>
          </Grid>
        </Paper>
      </Dialog>
    </>
  );
};

export default CategoryCritereForm;
